import _ from "lodash"

export default function miscellaneousPlugin(chartOpts) {
  _.unset(chartOpts, "subtitle")
  _.unset(chartOpts, "pane")
  _.unset(chartOpts, "time")

  _.set(chartOpts, "exporting.enabled", false)
  _.set(chartOpts, "scrollbar.enabled", false)
  return chartOpts
}
